import React from 'react';
import { Check, X } from 'lucide-react';
import { UI_ACCENT, type UiAccent } from './portalTheme';

export const PortalChip: React.FC<{
  label: string;
  icon?: React.ElementType;
  selected?: boolean;
  accent?: UiAccent;
  onClick?: () => void;
  onRemove?: () => void;
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  title?: string;
  'aria-expanded'?: boolean;
}> = ({
  label,
  icon: Icon,
  selected = false,
  accent = 'blue',
  onClick,
  onRemove,
  className = '',
  type = 'button',
  disabled = false,
  title,
  'aria-expanded': ariaExpanded,
}) => {
  const t = UI_ACCENT[accent];
  const isToggle = Boolean(onClick && !onRemove);
  const shell = `inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-all duration-150 ${
    selected ? t.chipActive : t.chip
  } ${
    selected ? 'scale-[1.03] font-semibold' : ''
  } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:scale-[1.02] active:scale-[0.98]'} ${className}`;

  const renderLeadingIcon = () => {
    if (selected && isToggle) {
      return <Check className="w-3 h-3 shrink-0 text-current" aria-hidden />;
    }
    if (Icon) {
      return <Icon className={`w-3 h-3 shrink-0 ${selected ? 'opacity-100' : 'opacity-80'}`} aria-hidden />;
    }
    return null;
  };

  if (onRemove) {
    return (
      <span className={shell}>
        {Icon ? <Icon className="w-3 h-3 shrink-0 opacity-80" aria-hidden /> : null}
        <span>{label}</span>
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 rounded-full p-0.5 hover:bg-white/10"
          aria-label={`${label} entfernen`}
        >
          <X className="w-3 h-3" />
        </button>
      </span>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={shell}
      title={title}
      aria-pressed={isToggle ? selected : undefined}
      aria-label={isToggle ? `${title || label}, ${selected ? 'aktiv' : 'inaktiv'}` : (title || label)}
      {...(ariaExpanded !== undefined ? { 'aria-expanded': ariaExpanded } : {})}
    >
      {renderLeadingIcon()}
      {label}
    </button>
  );
};
